import { asyncToGenerator as _asyncToGenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';

var setPreference = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(key, value) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            localStorage.setItem(key, value);

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function setPreference(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getPreference = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(key) {
    var value;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            value = localStorage.getItem(key);
            return _context2.abrupt("return", Promise.resolve(value));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getPreference(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var WebPreferenceStoreProvider = {
  setPreference: setPreference,
  getPreference: getPreference
};

export { WebPreferenceStoreProvider };
